/**
 * Employee Web — `/team/*` pathless parent.
 *
 * Phase 08.1 Plan 08 — new "My Team" subtree per CONTEXT D-13/D-14.
 * URL pattern: `me` = "my own data", `team` = "people who report to me".
 *
 * Children (each gates on its own *:read:team permission per be-063):
 *   - /team/approvals   ← requests:approve:team
 *   - /team/attendance  ← attendance:read:team
 *   - /team/leaves      ← leave:read:team
 *   - /team/performance ← appraisal:review:read:team
 *   - /team/directory   ← employees:read:team
 *
 * Each child renders its live screen (Team{Approvals,Attendance,Leaves,
 * Performance,Directory}Screen).
 */
import type { JSX } from "react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/team")({
  staticData: { breadcrumb: { labelKey: "team:nav.group" } },
  component: TeamPathlessParent,
});

function TeamPathlessParent(): JSX.Element {
  return <Outlet />;
}
